import { inherits as _inherits, createSuper as _createSuper, createClass as _createClass, classCallCheck as _classCallCheck } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { clickAnimationDuration } from '../Dwindle/DwindlePresentation.js';
import { defaultProps, ButtonPresentation } from './ButtonPresentation.js';

var ButtonWrapper = /*#__PURE__*/function (_React$Component) {
  _inherits(ButtonWrapper, _React$Component);

  var _super = _createSuper(ButtonWrapper);

  function ButtonWrapper(props) {
    var _this;

    _classCallCheck(this, ButtonWrapper);

    _this = _super.call(this, props);
    _this.state = {
      hasKeyboardFocus: false,
      hasMouseHover: false,
      clicked: false
    };
    return _this;
  }

  _createClass(ButtonWrapper, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.clearTimeout(this.timeout);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          hasKeyboardFocus = _this$state.hasKeyboardFocus,
          hasMouseHover = _this$state.hasMouseHover,
          clicked = _this$state.clicked;
      return /*#__PURE__*/React.createElement(ButtonPresentation, Object.assign({}, this.props, {
        hasKeyboardFocus: hasKeyboardFocus,
        onKeyboardFocusChange: function onKeyboardFocusChange(newFocus) {
          return _this2.setState({
            hasKeyboardFocus: newFocus
          });
        },
        hasMouseHover: hasMouseHover,
        onMouseHoverChange: function onMouseHoverChange(newHover) {
          return _this2.setState({
            hasMouseHover: newHover
          });
        },
        onClick: function onClick() {
          if (!_this2.props.disabled) {
            var _this2$props;

            _this2.setState({
              clicked: true
            });

            _this2.timeout = window.setTimeout(function () {
              return _this2.setState({
                clicked: false
              });
            }, clickAnimationDuration);

            (_this2$props = _this2.props).onClick.apply(_this2$props, arguments);
          }
        },
        clicked: clicked
      }), this.props.children);
    }
  }]);

  return ButtonWrapper;
}(React.Component);

ButtonWrapper.defaultProps = defaultProps;

export { ButtonWrapper };
